import React from "react";
import {
  Breadcrumbs,
  Link,
  Typography,
  Box,
} from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const AutobiaBreadcrumbs = ({
  items,
  maxItems = 8,
  separator,
}) => {
  const theme = useTheme();

  const defaultSeparator = separator || <NavigateNextIcon fontSize="small" />;

  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs
        maxItems={maxItems}
        separator={defaultSeparator}
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: theme.palette.gray.g400,
          },
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          if (isLast) {
            return (
              <Typography
                key={index}
                variant="body2"
                color="gray.g700"
                fontWeight={600}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={index}
              underline="hover"
              color="gray.g500"
              href={item.href}
              onClick={item.onClick}
              sx={{
                fontSize: "0.875rem",
                fontWeight: 500,
                cursor: item.onClick || item.href ? "pointer" : "default",
                "&:hover": {
                  color: "primary.main",
                },
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default AutobiaBreadcrumbs;